import { EventBus } from "@/utils/event-bus.js";
import store from "@/store";
import { getIconByDirection } from "@/utils/VehicleHelper";

function VeicleLastGps() {
  this.destroyFlag = 0; //1 表示销毁  0 表示不销毁
  this.map;
  this.gpsInfo;
  this.vehicleInfo;

  this.init = (map, vehicleinfo) => {
    this.map = map;
    this.vehicleInfo = vehicleinfo;
  };

  this.destroy = () => {
    if (this.map && this.gpsInfo) {
      // this.map.removeClustererById("v_" + this.gpsInfo.VehicleID);
    }
  };

  this.updateDestroyFlag = (flag) => {
    this.destroyFlag = flag;
  };

  this.updateGps = (info) => {
    if (this.gpsInfo == undefined) {
      this.gpsInfo = Object.assign({}, info);

      this.map.addMarkerToCluster(
        "v_" + this.gpsInfo.VehicleID,
        this.vehicleInfo.vehicleName + "(" + this.gpsInfo.Speed + " km/h)",
        this.gpsInfo.Lon,
        this.gpsInfo.Lat,
        getIconByDirection(this.gpsInfo.Direction),
        () => {
          EventBus.$emit("showOnMapEvent", {
            gpsInfo: this.gpsInfo,
            vehicleInfo: this.vehicleInfo,
          });
        }
      );
    } else {
      if (this.gpsInfo.Lon != info.Lon || this.gpsInfo.Lat != info.Lat || this.gpsInfo.Speed != info.Speed) {
        if (this.map) {
          // this.map.removeClustererById("v_" + this.gpsInfo.VehicleID);

          this.map.addMarkerToCluster(
            "v_" + this.gpsInfo.VehicleID,
            this.vehicleInfo.vehicleName + "(" + this.gpsInfo.Speed + " km/h)",
            this.gpsInfo.Lon,
            this.gpsInfo.Lat,
            getIconByDirection(this.gpsInfo.Direction),
            () => {
              EventBus.$emit("showOnMapEvent", {
                gpsInfo: this.gpsInfo,
                vehicleInfo: this.vehicleInfo,
              });
            }
          );
        }
      }
      this.gpsInfo = Object.assign({}, info);
    }
  };
}

export { VeicleLastGps };